import { render, staticRenderFns } from "./MenuCategory.vue?vue&type=template&id=39db94d9"
import script from "./MenuCategory.vue?vue&type=script&lang=js"
export * from "./MenuCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports